/* eslint-disable */
import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import * as Store from '@apply/store';
import { stateSelectorValues, ShowIf, countyList } from '@apply/ui';
import { useAuthentication } from '../../LoginPage';
import { alertModal } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { BusinessAndPeopleApi } from '@apply/api';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { LoadPanel } from 'devextreme-react/load-panel';
import MaskedInput from 'react-text-mask';

export interface EditUmbrellaBusinessModalProps {
    isOpen: boolean;
    onCloseCallback?: () => void;
    applicationInsights: ApplicationInsights;
    companyId: any;
}

export const EditUmbrellaBusinessModal: React.FC<EditUmbrellaBusinessModalProps> = ({
    isOpen,
    onCloseCallback,
    applicationInsights,
    companyId,
}) => {
    const businessAndPeopleApi = new BusinessAndPeopleApi.BusinessAndPeopleApi(applicationInsights);

    const { authentication, isFeatureEnabled } = useAuthentication();
    const [validation, set_validation] = useState(undefined);
    const [loadingMessage, set_loadingMessage] = useState('');
    const [loadingOpen, set_loadingOpen] = useState(false);

    const [business, set_business] = useState(null);
    const [canContinue, set_canContinue] = useState(true);

    const [mailingAddressCountySelectList, set_MailingAddressCountySelectList] = useState<{ value: string; display: string }[]>(
        []
    );

    const [physicalAddressCountySelectList, set_PhysicalAddressCountySelectList] = useState<{ value: string; display: string }[]>(
        []
    );
    const [businessId, set_businessId] = useState<number>(0);
    const [name, set_name] = useState<string>('');
    const [webSite, set_webSite] = useState<string>('');
    const [street1, set_street1] = useState<string>('');
    const [street2, set_street2] = useState<string>('');
    const [city, set_city] = useState<string>('');
    const [state, set_state] = useState<string>('');
    const [zipCode, set_zipcode] = useState<string>('');
    const [county, set_county] = useState<string>('');
    const [physicalAddressSameAsMailing, set_physicalAddressSameAsMailing] = useState<boolean>(false);
    const [physicalAddressStreet1, set_physicalAddressStreet1] = useState<string>('');
    const [physicalAddressStreet2, set_physicalAddressStreet2] = useState<string>('');
    const [physicalAddressCity, set_physicalAddressCity] = useState<string>('');
    const [physicalAddressState, set_physicalAddressState] = useState<string>('');
    const [physicalAddressZipCode, set_physicalAddressZipCode] = useState<string>('');
    const [physicalAddressCounty, set_physicalAddressCounty] = useState<string>('');

    const styles = {
        physicalAddressSection: {
            paddingLeft: '25px',
            paddingRight: '20px',
            paddingTop: '15px',
            border: '1px solid lightgray',
            borderRadius: '8px',
            backgroundColor: 'whitesmoke',
            color: 'rgba(42, 82, 139, 1)',
            display: physicalAddressSameAsMailing ? 'none' : 'block',
        },
        noPadding: {
            padding: 0,
        },
        checkbox: {
            marginRight: '5px',
        },
    };

    useEffect(() => {
        const tempCountyList = countyList
            .filter((county) => county.state === state)
            .map((county) => {
                return { display: county.county, value: county.county };
            });
        tempCountyList.unshift({ display: '', value: '' });
        set_MailingAddressCountySelectList(tempCountyList);
    }, [state]);

    useEffect(() => {
        const tempCountyList = countyList
            .filter((county) => county.state === physicalAddressState)
            .map((county) => {
                return { display: county.county, value: county.county };
            });
        tempCountyList.unshift({ display: '', value: '' });
        set_PhysicalAddressCountySelectList(tempCountyList);
    }, [physicalAddressState]);

    const loadDetails = async (id: number) => {
        set_loadingMessage('Loading...');
        set_loadingOpen(true);
        const response = await businessAndPeopleApi.getBorrowerBusinessById(id);
        if (!response || response.statusCode !== 200) {
            return;
        }
        set_business(response.result);
    };

    useEffect(() => {
        async function companyIdChanged() {
            resetState();
            if (!companyId || companyId <= 0) {
                set_businessId(0);
                return;
            }

            await loadDetails(companyId);
            set_loadingOpen(false);
        }

        companyIdChanged();
    }, [companyId]);

    useEffect(() => {
        setState(business);
    }, [business]);

    useEffect(() => {
        let fieldsValid = false;

        fieldsValid = name !== '' && street1 !== '' && state !== '' && city !== '' && zipCode != '';

        set_canContinue(fieldsValid);
    }, [name, street1, state, city, zipCode]);

    const resetState = () => {
        set_businessId(0);
        set_name('');
        set_webSite('');
        set_street1('');
        set_street2('');
        set_city('');
        set_state('');
        set_zipcode('');
        set_county('');
        set_physicalAddressSameAsMailing(false);
        set_physicalAddressStreet1('');
        set_physicalAddressStreet2('');
        set_physicalAddressCity('');
        set_physicalAddressState('');
        set_physicalAddressZipCode('');
        set_physicalAddressCounty('');
    };

    const setState = (business: any) => {
        if (business) {
            set_businessId(business.companyId);
            set_name(business.name);
            set_webSite(business.webSite);
            set_street1(business.street1);
            set_street2(business.street2);
            set_city(business.city);
            set_state(business.state);
            set_zipcode(business.zipCode);
            set_county(business.county);
            set_physicalAddressSameAsMailing(business.physicalAddressSameAsMailing);
            set_physicalAddressStreet1(business.physicalAddressStreet1);
            set_physicalAddressStreet2(business.physicalAddressStreet2);
            set_physicalAddressCity(business.physicalAddressCity);
            set_physicalAddressState(business.physicalAddressState);
            set_physicalAddressZipCode(business.physicalAddressZipCode);
            set_physicalAddressCounty(business.physicalAddressCounty);
        } else {
            resetState();
        }
    };

    useEffect(() => {
        if (physicalAddressSameAsMailing) {
            set_physicalAddressStreet1(street1);
            set_physicalAddressStreet2(street2);
            set_physicalAddressCity(city);
            set_physicalAddressState(state);
            set_physicalAddressCounty(county);
            set_physicalAddressZipCode(zipCode);
        }
    }, [physicalAddressSameAsMailing, street1, street2, city, state, zipCode, county]);

    const getSuccessMessage = (id: number) => {
        if (id === 0) {
            return 'Your Business was added successfully.';
        } else {
            return 'Your Business was updated successfully';
        }
    };

    const getGeneralErrorMessage = () => {
        return 'An error has occurred while communicating with our server.  Please try your operation again.';
    };

    const handleClose = () => {
        set_business(null);
        set_validation(undefined);
        resetState();
        onCloseCallback(null);
    };

    const cancelUmbrellaBusiness = () => {
        set_business(null);
        set_validation(undefined);
        resetState();
        onCloseCallback(null);
    };

    const saveUmbrellaBusiness = async () => {
        try {
            const model = {
                companyId: businessId ?? 0,
                name,
                webSite,
                street1,
                street2,
                city,
                state,
                zipCode,
                county,
                physicalAddressSameAsMailing,
                physicalAddressStreet1,
                physicalAddressStreet2,
                physicalAddressCity,
                physicalAddressState,
                physicalAddressZipCode,
                physicalAddressCounty,
            };
            const response = await businessAndPeopleApi.saveBorrowerBusiness(model);
            if (response.statusCode !== 200 || !response.result) {
                set_loadingOpen(false);
                return false;
            } else {
                if (response.result.hasErrors || response.result.hasWarnings) {
                    set_validation(response.result);
                    set_loadingOpen(false);
                    return false;
                }
                set_loadingOpen(false);
                alertModal({
                    title: 'Success',
                    message: getSuccessMessage(model.companyId),
                    onConfirm: () => {
                        handleClose();
                    },
                });
            }
        } catch (ex) {
            set_loadingOpen(false);
            set_validation(undefined);
            alertModal({
                message: getGeneralErrorMessage(),
            });
            return false;
        }
    };

    return (
        <div>
            <Dialog
                open={isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                maxWidth='md'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            role='dialog'
                            style={{ width: '800px', maxWidth: '80vw' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>{!businessId && businessId === 0 ? 'Add Business' : 'Edit Business'}</h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={handleClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                <div className='modal-content '>
                                    <div className='modal-body'>
                                        <div
                                            className='standard-form'
                                            style={styles.noPadding}
                                        >
                                            <div
                                                className='scrollable-content'
                                                style={{ margin: '10px' }}
                                            >
                                                <ShowIf showIf={validation?.hasErrors}>
                                                    {validation?.messages?.map((m) => {
                                                        return (
                                                            <div className='row'>
                                                                <div className='columns small-12 large-12'>
                                                                    <div>
                                                                        <span
                                                                            style={{
                                                                                color: 'red',
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={faExclamationTriangle}
                                                                                style={{
                                                                                    color: 'red',
                                                                                }}
                                                                            />
                                                                            &nbsp;
                                                                            <span
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: m.message,
                                                                                }}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </ShowIf>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='companyName'>
                                                            General or Umbrella Company Name <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            id='companyName'
                                                            type='text'
                                                            maxLength={100}
                                                            value={name}
                                                            onChange={(event) => set_name(event.target.value)}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='webSite'>Website</label>
                                                        <input
                                                            id='webSite'
                                                            placeholder='www.somecompany.com'
                                                            type='text'
                                                            maxLength={100}
                                                            value={webSite}
                                                            onChange={(event) => set_webSite(event.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='businessandpeople-modal-subheader'>Mailing Address</div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='street1'>
                                                            Street Address
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            id='street1'
                                                            type='text'
                                                            placeholder='123 Main Street'
                                                            maxLength={100}
                                                            value={street1}
                                                            onChange={(event) => set_street1(event.target.value)}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <input
                                                            id='street2'
                                                            type='text'
                                                            placeholder='Suite 123'
                                                            maxLength={100}
                                                            value={street2}
                                                            onChange={(event) => set_street2(event.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='city'>
                                                            City <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            id='city'
                                                            type='text'
                                                            maxLength={100}
                                                            placeholder='Hamilton'
                                                            value={city}
                                                            onChange={(event) => set_city(event.target.value)}
                                                            required={true}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-5'>
                                                        <label htmlFor='state'>
                                                            State <span className='req'>*</span>
                                                        </label>
                                                        <select
                                                            id={'state'}
                                                            value={state ?? ''}
                                                            onChange={(event) => set_state(event.target.value)}
                                                            required={true}
                                                        >
                                                            {stateSelectorValues.map((v, i) => {
                                                                return (
                                                                    <option
                                                                        key={i}
                                                                        value={v.value}
                                                                    >
                                                                        {v.display}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                    <div className='columns small-12 large-3'>
                                                        <label htmlFor='zipCode'>
                                                            Zip Code <span className='req'>*</span>
                                                        </label>
                                                        <MaskedInput
                                                            id='zipCode'
                                                            mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
                                                            guide={true}
                                                            type='text'
                                                            placeholder='12345'
                                                            value={zipCode}
                                                            onChange={(event) => set_zipcode(event.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-4'>
                                                        <label htmlFor={'county'}>County</label>
                                                        <select
                                                            id={'county'}
                                                            value={county ?? ''}
                                                            onChange={(event) => set_county(event.target.value)}
                                                        >
                                                            {mailingAddressCountySelectList.map((v, i) => {
                                                                return (
                                                                    <option
                                                                        key={i}
                                                                        value={v.value}
                                                                    >
                                                                        {v.display}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <input
                                                            id='physicalAddressSameAsMailing'
                                                            type='checkbox'
                                                            onChange={(event) =>
                                                                set_physicalAddressSameAsMailing(event.target.checked)
                                                            }
                                                            checked={physicalAddressSameAsMailing}
                                                            style={styles.checkbox}
                                                        />
                                                        <label htmlFor='physicalAddressSameAsMailing'>
                                                            Physical Address Same As Mailing Address
                                                        </label>
                                                    </div>
                                                </div>
                                                <div style={styles.physicalAddressSection}>
                                                    <div className='row'>
                                                        <div className='businessandpeople-modal-subheader'>Physical Address</div>
                                                    </div>
                                                    <div className='card'>
                                                        <div className='card-section'>
                                                            <div className='row'>
                                                                <div className='columns small-12 large-12'>
                                                                    <label htmlFor='physicalStreet1'>Street Address</label>
                                                                    <input
                                                                        id='physicalStreet1'
                                                                        type='text'
                                                                        placeholder='123 Main Street'
                                                                        maxLength={100}
                                                                        value={physicalAddressStreet1}
                                                                        disabled={physicalAddressSameAsMailing}
                                                                        onChange={(event) =>
                                                                            set_physicalAddressStreet1(event.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='columns small-12 large-12'>
                                                                    <input
                                                                        id='physicalStreet2'
                                                                        type='text'
                                                                        placeholder='Suite 123'
                                                                        maxLength={100}
                                                                        disabled={physicalAddressSameAsMailing}
                                                                        value={physicalAddressStreet2}
                                                                        onChange={(event) =>
                                                                            set_physicalAddressStreet2(event.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='columns small-12 large-12'>
                                                                    <label htmlFor='physicalCity'>City</label>
                                                                    <input
                                                                        id='physicalCity'
                                                                        type='text'
                                                                        placeholder='Hamilton'
                                                                        maxLength={100}
                                                                        disabled={physicalAddressSameAsMailing}
                                                                        value={physicalAddressCity}
                                                                        onChange={(event) =>
                                                                            set_physicalAddressCity(event.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='columns small-12 large-5'>
                                                                    <label htmlFor='physicalAddressState'>State</label>
                                                                    <select
                                                                        id={'physicalAddressState'}
                                                                        value={physicalAddressState ?? ''}
                                                                        onChange={(event) =>
                                                                            set_physicalAddressState(event.target.value)
                                                                        }
                                                                        disabled={physicalAddressSameAsMailing}
                                                                    >
                                                                        {stateSelectorValues.map((v, i) => {
                                                                            return (
                                                                                <option
                                                                                    key={i}
                                                                                    value={v.value}
                                                                                >
                                                                                    {v.display}
                                                                                </option>
                                                                            );
                                                                        })}
                                                                    </select>
                                                                </div>
                                                                <div className='columns small-12 large-3'>
                                                                    <label htmlFor='physicalAddressZipCode'>Zip Code</label>
                                                                    <MaskedInput
                                                                        id='physicalAddressZipCode'
                                                                        mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
                                                                        guide={true}
                                                                        type='text'
                                                                        placeholder='12345'
                                                                        value={physicalAddressZipCode}
                                                                        onChange={(event) =>
                                                                            set_physicalAddressZipCode(event.target.value)
                                                                        }
                                                                        disabled={physicalAddressSameAsMailing}
                                                                    />
                                                                </div>
                                                                <div className='columns small-12 large-4'>
                                                                    <label htmlFor={'physicalAddressCounty'}>County</label>
                                                                    <select
                                                                        id={'physicalAddressCounty'}
                                                                        value={physicalAddressCounty ?? ''}
                                                                        onChange={(event) =>
                                                                            set_physicalAddressCounty(event.target.value)
                                                                        }
                                                                        disabled={physicalAddressSameAsMailing}
                                                                    >
                                                                        {physicalAddressCountySelectList.map((v, i) => {
                                                                            return (
                                                                                <option
                                                                                    key={i}
                                                                                    value={v.value}
                                                                                >
                                                                                    {v.display}
                                                                                </option>
                                                                            );
                                                                        })}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='modal-content-actions'>
                                                    <button
                                                        type='button'
                                                        data-testid='accept-button'
                                                        className='button primary'
                                                        style={{ width: '150px' }}
                                                        onClick={cancelUmbrellaBusiness}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type='button'
                                                        data-testid='accept-button'
                                                        className='button primary'
                                                        style={{ width: '150px' }}
                                                        onClick={saveUmbrellaBusiness}
                                                        disabled={!canContinue}
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
        </div>
    );
};
